"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GameDownloadCompleteDTO = exports.GameDownloadStartDTO = exports.GameDownloadDTO = exports.GameUpdateCompleteDTO = exports.GameUpdateStartDTO = exports.GameInstallCompleteDTO = exports.GameInstallStartDTO = exports.GameInstallQueueDTO = exports.GameGiveAllowanceDTO = exports.GameplayBeginDTO = void 0;
const class_validator_1 = require("class-validator");
const decorators_1 = require("../decorators");
const types_1 = require("../types");
const enum_1 = require("../types/enum");
const dto_factory_1 = require("../types/dto-factory");
let GameplayBeginDTO = class GameplayBeginDTO extends (0, dto_factory_1.DTOFactory)(types_1.GalEvents.GameplayBeginDTO) {
    constructor() {
        super(...arguments);
        Object.defineProperty(this, "game", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "version", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "platform", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "launcherVersion", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
    }
};
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsNotEmpty)(),
    (0, decorators_1.Describe)('Game Name'),
    __metadata("design:type", String)
], GameplayBeginDTO.prototype, "game", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)(),
    (0, decorators_1.Describe)('Game version'),
    __metadata("design:type", String)
], GameplayBeginDTO.prototype, "version", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)(),
    (0, decorators_1.Describe)('Game platform'),
    __metadata("design:type", String)
], GameplayBeginDTO.prototype, "platform", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)(),
    (0, decorators_1.Describe)('Current Launcher Version'),
    __metadata("design:type", String)
], GameplayBeginDTO.prototype, "launcherVersion", void 0);
GameplayBeginDTO = __decorate([
    (0, decorators_1.Describe)('Gameplay start event')
], GameplayBeginDTO);
exports.GameplayBeginDTO = GameplayBeginDTO;
let GameGiveAllowanceDTO = class GameGiveAllowanceDTO extends (0, dto_factory_1.DTOFactory)(types_1.GalEvents.GameGiveAllowanceDTO) {
    constructor() {
        super(...arguments);
        Object.defineProperty(this, "game", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "version", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "platform", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "metadata", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
    }
};
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsNotEmpty)(),
    (0, decorators_1.Describe)('Game Name'),
    __metadata("design:type", String)
], GameGiveAllowanceDTO.prototype, "game", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)(),
    (0, decorators_1.Describe)('Game version'),
    __metadata("design:type", String)
], GameGiveAllowanceDTO.prototype, "version", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)(),
    (0, decorators_1.Describe)('Game platform'),
    __metadata("design:type", String)
], GameGiveAllowanceDTO.prototype, "platform", void 0);
__decorate([
    (0, class_validator_1.IsObject)(),
    (0, class_validator_1.IsOptional)(),
    (0, decorators_1.Describe)('Additional allowance details'),
    __metadata("design:type", Object)
], GameGiveAllowanceDTO.prototype, "metadata", void 0);
GameGiveAllowanceDTO = __decorate([
    (0, decorators_1.Describe)('User allowance granted to game for duration')
], GameGiveAllowanceDTO);
exports.GameGiveAllowanceDTO = GameGiveAllowanceDTO;
let GameInstallQueueDTO = class GameInstallQueueDTO extends (0, dto_factory_1.DTOFactory)(types_1.GalEvents.GameInstallQueueDTO) {
    constructor() {
        super(...arguments);
        Object.defineProperty(this, "game", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "version", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "platform", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
    }
};
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsNotEmpty)(),
    (0, decorators_1.Describe)('Game Name'),
    __metadata("design:type", String)
], GameInstallQueueDTO.prototype, "game", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)(),
    (0, decorators_1.Describe)('Game version'),
    __metadata("design:type", String)
], GameInstallQueueDTO.prototype, "version", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)(),
    (0, decorators_1.Describe)('Game Platform'),
    __metadata("design:type", String)
], GameInstallQueueDTO.prototype, "platform", void 0);
GameInstallQueueDTO = __decorate([
    (0, decorators_1.Describe)('Game installation requested, and waiting')
], GameInstallQueueDTO);
exports.GameInstallQueueDTO = GameInstallQueueDTO;
let GameInstallStartDTO = class GameInstallStartDTO extends (0, dto_factory_1.DTOFactory)(types_1.GalEvents.GameInstallStartDTO) {
    constructor() {
        super(...arguments);
        Object.defineProperty(this, "game", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "version", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "platform", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
    }
};
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsNotEmpty)(),
    (0, decorators_1.Describe)('Game Name'),
    __metadata("design:type", String)
], GameInstallStartDTO.prototype, "game", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)(),
    (0, decorators_1.Describe)('Game version'),
    __metadata("design:type", String)
], GameInstallStartDTO.prototype, "version", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)(),
    (0, decorators_1.Describe)('Game Platform'),
    __metadata("design:type", String)
], GameInstallStartDTO.prototype, "platform", void 0);
GameInstallStartDTO = __decorate([
    (0, decorators_1.Describe)('Game installation began')
], GameInstallStartDTO);
exports.GameInstallStartDTO = GameInstallStartDTO;
let GameInstallCompleteDTO = class GameInstallCompleteDTO extends (0, dto_factory_1.DTOFactory)(types_1.GalEvents.GameInstallCompleteDTO) {
    constructor() {
        super(...arguments);
        Object.defineProperty(this, "game", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "version", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "platform", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
    }
};
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsNotEmpty)(),
    (0, decorators_1.Describe)('Game Name'),
    __metadata("design:type", String)
], GameInstallCompleteDTO.prototype, "game", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)(),
    (0, decorators_1.Describe)('Game version'),
    __metadata("design:type", String)
], GameInstallCompleteDTO.prototype, "version", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)(),
    (0, decorators_1.Describe)('Game Platform'),
    __metadata("design:type", String)
], GameInstallCompleteDTO.prototype, "platform", void 0);
GameInstallCompleteDTO = __decorate([
    (0, decorators_1.Describe)('Game installation completed successfully')
], GameInstallCompleteDTO);
exports.GameInstallCompleteDTO = GameInstallCompleteDTO;
let GameUpdateStartDTO = class GameUpdateStartDTO extends (0, dto_factory_1.DTOFactory)(types_1.GalEvents.GameUpdateStartDTO) {
    constructor() {
        super(...arguments);
        Object.defineProperty(this, "game", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "version", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "platform", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
    }
};
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsNotEmpty)(),
    (0, decorators_1.Describe)('Game Name'),
    __metadata("design:type", String)
], GameUpdateStartDTO.prototype, "game", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)(),
    (0, decorators_1.Describe)('Game version'),
    __metadata("design:type", String)
], GameUpdateStartDTO.prototype, "version", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)(),
    (0, decorators_1.Describe)('Game Platform'),
    __metadata("design:type", String)
], GameUpdateStartDTO.prototype, "platform", void 0);
GameUpdateStartDTO = __decorate([
    (0, decorators_1.Describe)('Game update started')
], GameUpdateStartDTO);
exports.GameUpdateStartDTO = GameUpdateStartDTO;
let GameUpdateCompleteDTO = class GameUpdateCompleteDTO extends (0, dto_factory_1.DTOFactory)(types_1.GalEvents.GameUpdateCompleteDTO) {
    constructor() {
        super(...arguments);
        Object.defineProperty(this, "game", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "version", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "platform", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
    }
};
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsNotEmpty)(),
    __metadata("design:type", String)
], GameUpdateCompleteDTO.prototype, "game", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)(),
    (0, decorators_1.Describe)('Game version'),
    __metadata("design:type", String)
], GameUpdateCompleteDTO.prototype, "version", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)(),
    (0, decorators_1.Describe)('Game Platform'),
    __metadata("design:type", String)
], GameUpdateCompleteDTO.prototype, "platform", void 0);
GameUpdateCompleteDTO = __decorate([
    (0, decorators_1.Describe)('Game update completed successfully')
], GameUpdateCompleteDTO);
exports.GameUpdateCompleteDTO = GameUpdateCompleteDTO;
let GameDownloadDTO = class GameDownloadDTO extends (0, dto_factory_1.DTOFactory)(types_1.GalEvents.GameDownloadDTO) {
    constructor() {
        super(...arguments);
        Object.defineProperty(this, "game", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "version", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "platform", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "payloadType", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
    }
};
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsNotEmpty)(),
    __metadata("design:type", String)
], GameDownloadDTO.prototype, "game", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)(),
    (0, decorators_1.Describe)('Game version'),
    __metadata("design:type", String)
], GameDownloadDTO.prototype, "version", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)(),
    (0, decorators_1.Describe)('Game Platform'),
    __metadata("design:type", String)
], GameDownloadDTO.prototype, "platform", void 0);
__decorate([
    (0, class_validator_1.IsEnum)(enum_1.GamePayloadType),
    (0, class_validator_1.IsIn)(Object.values(enum_1.GamePayloadType)),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", String)
], GameDownloadDTO.prototype, "payloadType", void 0);
GameDownloadDTO = __decorate([
    (0, decorators_1.Describe)('Game payload download without complete notification')
], GameDownloadDTO);
exports.GameDownloadDTO = GameDownloadDTO;
let GameDownloadStartDTO = class GameDownloadStartDTO extends (0, dto_factory_1.DTOFactory)(types_1.GalEvents.GameDownloadStartDTO) {
    constructor() {
        super(...arguments);
        Object.defineProperty(this, "game", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "version", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "platform", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
    }
};
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsNotEmpty)(),
    __metadata("design:type", String)
], GameDownloadStartDTO.prototype, "game", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)(),
    (0, decorators_1.Describe)('Game version'),
    __metadata("design:type", String)
], GameDownloadStartDTO.prototype, "version", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)(),
    (0, decorators_1.Describe)('Game Platform'),
    __metadata("design:type", String)
], GameDownloadStartDTO.prototype, "platform", void 0);
GameDownloadStartDTO = __decorate([
    (0, decorators_1.Describe)('Game download started'),
    (0, decorators_1.Warning)('Use GameDownload if no completion event will be captured')
], GameDownloadStartDTO);
exports.GameDownloadStartDTO = GameDownloadStartDTO;
let GameDownloadCompleteDTO = class GameDownloadCompleteDTO extends (0, dto_factory_1.DTOFactory)(types_1.GalEvents.GameDownloadCompleteDTO) {
    constructor() {
        super(...arguments);
        Object.defineProperty(this, "game", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "version", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "platform", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
    }
};
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsNotEmpty)(),
    __metadata("design:type", String)
], GameDownloadCompleteDTO.prototype, "game", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)(),
    (0, decorators_1.Describe)('Game version'),
    __metadata("design:type", String)
], GameDownloadCompleteDTO.prototype, "version", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)(),
    (0, decorators_1.Describe)('Game Platform'),
    __metadata("design:type", String)
], GameDownloadCompleteDTO.prototype, "platform", void 0);
GameDownloadCompleteDTO = __decorate([
    (0, decorators_1.Describe)('Game download finished'),
    (0, decorators_1.Warning)('Use GameDownload if no completion event will be captured')
], GameDownloadCompleteDTO);
exports.GameDownloadCompleteDTO = GameDownloadCompleteDTO;
